<style lang="less">
  @import "./Home.less";
</style>

<template>
  <div class="home">

    <div class="home-top" id="home-top" :style="{'height': bannerHeight + 'px'}">
      <!--广告-->
      <!--autoplay轮播间隔,show-indicators是否显示指示器,给van-swipe加高度是解决图片超过2张时无法正常显示指示器的问题-->
      <van-swipe :autoplay="3000" :style="{'height': bannerHeight + 'px'}" indicator-color="#02aeff">
        <van-swipe-item v-for="(image, index) in adList" :key="index" @click="toAdLinkFn(image.to, image.url)">
          <img :alt="image.title || '欢迎您'" v-lazy="image.img_url" />
          <!--<img :alt="image.title || '欢迎您'" :src="image.img_url">-->
        </van-swipe-item>
      </van-swipe>
      <!--<img alt="欢迎您" src="../assets/images/img_header.png">-->
      <div :class="[topTextPosition==='right'?'home-top-right showCustomer':'home-top-left showCustomer',topTextColor==='black'?'home-top-black showCustomer':topTextColor==='theme'?'home-top-theme showCustomer':'home-top-white showCustomer']">
        <h3 v-if="showCustomer">{{customerName}}</h3>
        <p v-for="(item, index) in customerIntroduce" :key="index">{{item}}</p>
      </div>
    </div>
    <div class="home-notice" v-if="noticeText" @click="onClickNotice">
      <van-notice-bar
        :text="noticeText"
        color="#474848"
        background="#ebebec"
        left-icon="volume-o"
      />
    </div>

    <!--默认样式-->
    <!--<div>-->
      <!--<van-grid square :column-num="3" :clickable="true" :border="false">-->
        <!--<van-grid-item-->
          <!--v-for="item in menuList"-->
          <!--:key="item.id"-->
          <!--:icon="item.icon"-->
          <!--:text="item.text"-->
          <!--:to="item.to"-->
          <!--:url="item.url"-->
        <!--/>-->
      <!--</van-grid>-->
    <!--</div>-->

    <!--自定义样式-->
    <div class="home-menu">
      <van-grid square :column-num="3" :clickable="true" :border="false">
        <van-grid-item v-for="item in menuList" :key="item.id" @click="menuHandle(item)">
          <img alt="" :src="item.imgUrl">
          <p>{{item.text}}</p>
        </van-grid-item>
        <!-- <van-grid-item>
          <wx-open-launch-weapp
          id="launch-btn"
          username="gh_3b0f66784684"
          @error="handleErrorFn" @launch="handleLaunchFn"
          :path="`pages/liveList/index.html?token=${token}`"
        >
        <script type="text/wxtag-template">
        <style>.live{  display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;font-size:14px} .live p{padding:0;margin:0;margin-top:8%;font-weight: 700;} .live img{width:46%}</style>
        <div class='live'>
          <img alt="" src="http://res.spreadwin.com/wid/Tsy7CkFsiQFacHG.png">
          <p>直播</p>
        </div>
        </script>
        </wx-open-launch-weapp>
        </van-grid-item> -->
      </van-grid>
    </div>
  </div>
</template>

<script>
import Home from './Home.js'
export default {
  ...Home
}
</script>
